import Vue from "vue";

const routes = [{
    path: '/',
    redirect: '/the-magazine'
}, {
    path: '/home',
    component: resolve => require(['../containers/defaultContainer.vue'], resolve),
    children: [{
        path: '',
        component: resolve => require(['../components/Kiosko.vue'], resolve),
        meta: {
            title: 'Digital Magazine',
            requiresAuth: true
        }
    }, {
        path: '/payment/',
        component: resolve => require(['../views/payform.vue'], resolve),
        meta: {
            title: 'Payment',
            requiresAuth: true,
        }
    }, {
        path: '/change-password',
        component: resolve => require(['../views/auth/change-password.vue'], resolve),
        meta: {
            title: 'Change Password',
            requiresAuth: true,
        }
    }, {
        path: '/issue-12',
        component: resolve => require(['../views/issue12/Issue12.vue'], resolve),
        meta: {
            title: 'Issue 12 THE NEW ORDER',
            requiresAuth: true,
            asset:'prod_Qt3c3AktZMZSAF'
        }
    }, {
        path: '/issue-11',
        component: resolve => require(['../views/issue11/Issue11.vue'], resolve),
        meta: {
            title: 'Issue 11 EXPRESSION',
            requiresAuth: true,
            asset:'prod_Qt32hC6BzI4m0x'
        }
    }, {
        path: '/issue-10',
        component: resolve => require(['../views/issue10/Issue10.vue'], resolve),
        meta: {
            title: 'Issue 10 MUSIC',
            requiresAuth: true,
            asset:'prod_Qt32RMMUBFJmEL'
        }
    }, {
        path: '/issue-9',
        component: resolve => require(['../views/issue9/Issue9.vue'], resolve),
        meta: {
            title: 'Issue 9 IDENTITY',
            requiresAuth: true,
            asset:'prod_Qt32Q6SwTgIq1K'
        }
    }, {
        path: '/issue-8',
        component: resolve => require(['../views/issue8/Issue8.vue'], resolve),
        meta: {
            title: 'Issue 8 UNITED NATION',
            requiresAuth: true,
            asset:'prod_Qt32rs10Pd0sjD'
        }
    }, {
        path: '/issue-7',
        component: resolve => require(['../views/issue7/Issue7.vue'], resolve),
        meta: {
            title: 'Issue 7 THE SUSTAINABILITY',
            requiresAuth: true,
            asset:'prod_Qt32A6mxNUZF4d'
        }
    }, {
        path: '/issue-6',
        component: resolve => require(['../views/issue6/Issue6.vue'], resolve),
        meta: {
            title: 'Issue 6 THE BIPOC',
            requiresAuth: true,
            asset:'prod_Qt32Hj3UHNYbK3'
        }
    }, {
        path: '/issue-5',
        component: resolve => require(['../views/issue5/Issue5.vue'], resolve),
        meta: {
            title: 'Issue 5 HUMAN',
            requiresAuth: true,
            asset:'prod_Qt32hhBGjpjGe9'
        }
    }, {
        path: '/issue-4',
        component: resolve => require(['../views/issue4/Issue4.vue'], resolve),
        meta: {
            title: 'Issue 4 LGBTIQ+',
            requiresAuth: true,
            asset:'prod_Qt32XJ6nHwfovm'
        }
    }, {
        path: '/issue-3',
        component: resolve => require(['../views/issue3/Issue3.vue'], resolve),
        meta: {
            title: 'Issue 3 Youth',
            requiresAuth: true,
            asset:'prod_Qt31YfjsDtS55K'
        }
    }, {
        path: '/issue-2',
        component: resolve => require(['../views/issue2/Issue2.vue'], resolve),
        meta: {
            title: 'Issue 2 Enviroment',
            requiresAuth: true,
            asset: 'prod_Qt31g8e76j4Ooh'
        }
    }, {
        path: '/issue-1',
        component: resolve => require(['../views/issue1/Issue1.vue'], resolve),
        meta: {
            title: 'Issue 1 Women',
            requiresAuth: true,
            asset: 'prod_Qt315Uy3XNBdnO'
        }
    }, {
        path: '/colorbook/:id',
        component: resolve => require(['../components/viewpdf.vue'], resolve),
        meta: {
            title: 'Mission Magazin Coloring Book',
            requiresAuth: true
        }
    }]
}, {
    path: '/cart',
    component: resolve => require(['../views/library.vue'], resolve),
    meta: {
        title: 'Cart',
        requiresAuth: false
    }
}, {
    path: '/the-magazine',
    name: 'the-magazine',
    component: resolve => require(['../components/kioskWeb.vue'], resolve),
    meta: {
        title: 'Digital Magazine',
        requiresAuth: false
    }
}, {
    path: '/login',
    component: resolve => require(['../views/auth/Login.vue'], resolve),
    meta: {
        title: 'Login',
        requiresAuth: false
    }
}, {
    path: '/action',
    component: resolve => require(['../components/action.vue'], resolve),
    children: [{
        path: '/reset-password',
        name: 'reset-password',
        component: resolve => require(['../views/auth/new-password.vue'], resolve),
        meta: {
            title: 'reset Password',
            requiresAuth: false
        }
      },
      {
        path: '/error',
        name: 'Default',
        component: resolve => require(['../views/auth/errors.vue'], resolve),
        meta: {
            title: 'error',
            requiresAuth: false
        }
      }, 
      {
        path: '/verify-email',
        name: 'verify-email',
        component: resolve => require(['../views/auth/confirmEmail.vue'], resolve),
        meta: {
            title: 'Verify Email',
            requiresAuth: false
        }
      }, 
    ],
  },{
    path: '/lost-password',
    component: resolve => require(['../views/auth/restore-password.vue'], resolve),
    meta: {
        title: 'Lost Password',
        requiresAuth: false
    }
},/*  {
    path: '/reset-password',
    component: resolve => require(['../views/auth/new-password.vue'], resolve),
    meta: {
        title: 'reset Password',
        requiresAuth: false
    }
},  */{
    path: '/faq',
    component: resolve => require(['../views/faq.vue'], resolve),
    meta: {
        title: 'FAQ',
        requiresAuth: false
    }
}, {
    path: '/register',
    component: resolve => require(['../views/auth/Register.vue'], resolve),
    meta: {
        title: 'Register',
        requiresAuth: false
    }
}]

export default routes;